export default {
      id: "arrow-simple-right-usage",
      viewBox: "0 0 9 7",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#arrow-simple-right",
      toString: function () {
        return this.url;
      }
    }